// Berry-style Mini Drawer Component
// This component provides a collapsible sidebar with auto-hiding scrollbar

import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import drawerConfig from '../drawerConfig';

const drawerWidth = drawerConfig.width;
const miniDrawerWidth = drawerConfig.miniWidth;

// Drawer mixins for smooth transitions
function openedMixin(theme) {
  return {
    width: drawerWidth,
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  };
}

function closedMixin(theme) {
  return {
    overflowX: 'hidden',
    width: miniDrawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  };
}

// Berry-style mini drawer with auto-hiding scrollbar
const MiniDrawerStyled = styled(Drawer, { 
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'showScrollbar' 
})(({ theme, open, showScrollbar }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': {
      ...openedMixin(theme),
      marginTop: '64px',
      height: 'calc(100% - 64px)',
      overflowY: 'auto',
      overflowX: 'hidden',
      // Auto-hiding scrollbar like Berry theme
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: showScrollbar 
          ? (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.2)')
          : 'transparent',
        borderRadius: '4px',
        transition: 'background 0.3s ease',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.3)',
      },
      // Firefox
      scrollbarWidth: 'thin',
      scrollbarColor: showScrollbar
        ? (theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.3) transparent'
          : 'rgba(0,0,0,0.2) transparent')
        : 'transparent transparent',
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': {
      ...closedMixin(theme),
      marginTop: '64px',
      height: 'calc(100% - 64px)',
      overflowY: 'auto',
      overflowX: 'hidden',
      // Auto-hiding scrollbar like Berry theme
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: showScrollbar 
          ? (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.2)')
          : 'transparent',
        borderRadius: '4px',
        transition: 'background 0.3s ease',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.3)',
      },
      // Firefox
      scrollbarWidth: 'thin',
      scrollbarColor: showScrollbar
        ? (theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.3) transparent'
          : 'rgba(0,0,0,0.2) transparent')
        : 'transparent transparent',
    },
  }),
}));

export default MiniDrawerStyled;
